import { useMicRecorder } from './useMicRecorder';

// Records until ~1.6s of silence after speech (or tap to stop), then returns the audio blob.
export const useHandsFreeMic = (onBlob) => {
  const m = useMicRecorder({ onBlob, autoStop: true });
  return { ...m, listening: m.recording, start: () => m.start('record') };
};

export default useHandsFreeMic;
